<template>
  <div>
    <v-list-item class="px-0">
      <v-list-item-avatar
        tile
        class="ml-n5 mr-n3"
        :class="{ thumbnailStyle: thumbnail }"
        width="82"
        >
        <ScoreThresholdBadge
          :moduleBulb="moduleBulb"
          :scoreThreshold="scoreThreshold"
          :isScoreThresholdToggleEnabled="isScoreThresholdToggleEnabled"
          :thumbnail="thumbnail"
        />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-subtitle :class="{ 'pl-3': thumbnail }" class="text-left">{{ bulbName }}</v-list-item-subtitle>
      </v-list-item-content>
        <ScoreThresholdSettings
          :handleRemoveBulb="handleRemoveBulb"
          :handleEditBulb="handleEditBulb"
          :clearedScoreThreshold="clearedScoreThreshold"
          :pointsAvailable="pointsAvailable"
          :moduleBulb="moduleBulb"
        />
    </v-list-item>
  </div>
</template>

<script>
import {
  mapMutations,
  mapState,
  mapGetters,
  mapActions,
} from 'vuex';
import _ from 'lodash';

import ScoreThresholdBadge from './ScoreThresholdBadge.vue';
import ScoreThresholdSettings from './ScoreThresholdSettings.vue';

export default {
  name: 'DraggableBulb',
  props: [
    'moduleBulb',
    'thumbnail',
  ],
  components: {
    ScoreThresholdBadge,
    ScoreThresholdSettings,
  },
  methods: {
    ...mapActions([
      'getPlaylist',
      'removeItem',
    ]),
    ...mapMutations([
      'setIsUpdating',
      'toggleSnackbar',
    ]),
    handleRemoveBulb() {
      this.removeItem({
        playlistId: this.playlistId,
        moduleId: this.moduleBulb.moduleId,
        oldItemIndex: this.moduleBulb.order,
        itemId: this.moduleBulb.itemId,
        type: 'bulb',
      });
    },
    async handleEditBulb() {
      // If a user tries to edit a bulb but doesn't have a bulbTeacher row - create one
      try {
        this.setIsUpdating(true);
        if (![1, 2].includes(!_.get(this, 'moduleBulb.bulb.teachers[0].bulbTeacher.bulbRole', false))) {
          await this.$api.playlist.addBulbTeacherRow({
            bulbId: this.moduleBulb.bulb.id,
            playlistId: this.playlist.id,
          });
        }
      } catch (e) {
        console.error(e); // eslint-disable-line
      } finally {
        this.setIsUpdating(false);
      }
      const windowRef = window.open(
        `${this.$getServerUrl()}designer/?bulb_id=${this.moduleBulb.itemId}&token=${this.userToken}&lms_launch=${this.isLti}&playlist_launch=true`,
        '_blank',
      );
      const windowRefInterval = setInterval(async () => {
        if (windowRef?.closed) {
          clearInterval(windowRefInterval);
          this.toggleSnackbar({
            text: 'Successfully edited bulb!',
            color: 'success',
          });
          await this.getPlaylist({ playlistId: this.playlist.id });
        }
      }, 1000);
    },
  },
  computed: {
    ...mapState([
      'isLti',
      'isUpdating',
      'passbackBulbs',
      'playlistId',
      'playlist',
      'showSlideout',
      'user',
      'userToken',
    ]),
    ...mapGetters([
      'restrictPlaylistAccess',
    ]),
    bulbName() {
      return _.get(this.moduleBulb, 'bulb.name', 'Bulb Deleted (Remove)');
    },
    scoreThreshold: {
      get() {
        if (this.clearedScoreThreshold) return false;
        return this.moduleBulb.config?.scoreThreshold;
      },
      set(value) {
        this.$set(this.moduleBulb.config, 'scoreThreshold', value);
      },
    },
    isScoreThresholdToggleEnabled() { // only used for the `ScoreThresholdBadge` vue component
      return Boolean(
        (
          this.pointsAvailable > 0
          && this.bulbSettings?.bulb?.config?.retry_yes
        ),
      );
    },
    clearedScoreThreshold() {
      return this.moduleBulb.config?.clearedThresholdScore;
    },
    pointsAvailable() {
      return _.get(this.moduleBulb, 'bulb.pointsAvailable', 0);
    },
    bulbSettings() {
      return {
        bulb: this.moduleBulb.bulb,
      };
    },
  },
};
</script>

<style lang="scss">
  .thumbnailStyle {
    height: 36px !important;
    width: 64px !important;
    max-height: 36px !important;
    max-width: 64px !important;
  }
  .playlist-module-item-delete {
    &:hover {
      cursor: pointer;
    }
  }

  .percentage-number-input {
    width: 75px;
    display: inline-block;
  }
</style>
